import React from 'react';
import './index.css';

const ArchiveItem = ({ title, date, tags }) => {
  return (
    <div className="archive-item">
      <h4>{title}</h4>
      <div className="meta">
        <span className="date">{date}</span>
        <div className="tags">
          {tags.map((tag, idx) => (
            <span key={idx} className="tag">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArchiveItem;